import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-compass-3-line text-lg text-white"></i>
                </span>
                <span className="text-xl font-heading font-bold tracking-tight text-white whitespace-nowrap">
                  91浏览器
                </span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed max-w-xs">
                新一代高性能浏览器，致力于为全球用户提供极速、安全、智能的网页浏览体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">产品</h4>
              <ul className="space-y-3">
                <li><Link to="/categories" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">功能分类</Link></li>
                <li><a href="#download" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">下载中心</a></li>
                <li><a href="#features" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">功能介绍</a></li>
                <li><a href="#faq" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">资源</h4>
              <ul className="space-y-3">
                <li><Link to="/articles" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">文章资讯</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
                <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">更新日志</a></li>
                <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">帮助中心</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">法律</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">隐私政策</a></li>
                <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">服务条款</a></li>
                <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Cookie 政策</a></li>
                <li><a href="#" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">开源许可</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 91浏览器. 保留所有权利.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-foreground-700/50 text-foreground-300 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-foreground-700/50 text-foreground-300 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-foreground-700/50 text-foreground-300 hover:text-white transition-colors cursor-pointer" aria-label="GitHub">
                <i className="ri-github-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}